import React, { useEffect, useRef, useState } from "react"
import GoogleMapReact from "google-map-react"
import PinComponent from "../Common/PinComponent"
import "../../css/enhanced-list-view.css"
import { useVisitsPreferences } from "../../hooks/useLocalStorage"

interface PlaceRecord {
  id: string
  name: string
  image: string
  address?: string
  sector?: string
  city?: string
  region?: string
  country?: string
  assignedTo?: string
  assignedToObj?: {
    firstName: string
    lastName: string
  }
  latitude: number
  longitude: number
  latitudeStart?: number
  longitudeStart?: number
}

interface User {
  id: string
  firstName: string
  lastName: string
}

interface Category {
  id: string
  name: string
}

interface Stage {
  id: string
  name: string
}

interface PlaceStatus {
  id: string
  name: string
}

interface Sector {
  name: string
  count: number
}

import Settings from "../../common/Settings"
import { parsedUser } from "../../common/GetCurrentUser"
import API from "../../common/API"
import moment from "moment"
import { Routes } from "../../routes"
import { useHistory, useParams } from "react-router-dom"
import AssignUser from "../Users/AssignUser"
import { Card, Col, Row } from "react-bootstrap"
import SummaryByStage from "./SummaryByStage"
import AddEditPlace from "./AddEditPlace"
import { useTranslation } from "react-i18next"
import SummaryByStatus from "./SummaryByStatus"
import VisitHistorySidebar from "./VisitHistorySidebar"
import PlacePriority from "./PlacePriority"
import "./VisitHistorySidebar.css"
import SummaryVehicleVisits from "./SummaryVehicleVisits"

const Visits: React.FC = () => {
  const history = useHistory()
  const { t } = useTranslation("global")
  const heatmapRef = useRef(null);
  const isInitialMount = useRef(true); // Track initial mount to avoid duplicate requests
  // Use localStorage for user preferences
  const {
    displayMode,
    setDisplayMode,
    showFilter,
    setShowFilter,
    filter,
    setFilter,
    showFinished,
    setShowFinished,
    showTrucks,
    setShowTrucks
  } = useVisitsPreferences()

  // Local component states
  const [showHistory, setShowHistory] = useState(false)
  const [showPriority, setShowPriority] = useState(false)
  const [recordsVehicles, setRecordsVehicles] = useState([])
  const user = parsedUser()
  const [records, setRecords] = useState<PlaceRecord[]>([])
  const [visibleRecords, setVisibleRecords] = useState<PlaceRecord[]>([])
  const [isLoading, setIsLoading] = useState(false)
  const [loadingProgress, setLoadingProgress] = useState(0)
  const [isMobile, setIsMobile] = useState(false)
  const [totalRecords, setTotalRecords] = useState(0)
  const [currentPage, setCurrentPage] = useState(1)
  const [pageSize] = useState(100) // Cargar de 100 en 100
  const [requestSize, setRequestSize] = useState<string>('') // Para debug del tamaño de la petición
  const GoogleMapRef = useRef(null)
  const [mapMode, setMapMode] = useState<string | null>(null) //This is used to set the mode of the mode of the map; null = nothing; drawPolygon = allow to draw
  const [thePolygon, setThePolygon] = useState(null)

  // Modal toggle functions
  const togglePriorityModal = () => {
    setShowPriority(!showPriority)
  }
  const toggleHistoryModal = () => {
    setShowHistory(!showHistory)
  }
  const [state, setState] = useState({
    center: { lat: 18.479777, lng: -69.9341112 },
    zoom: 10,
    Devices: [],
    Pins: [],
    Geofences: [],
    DeviceSelected: null,
    Events: [],
    UI: {
      showAddEditGeofence: false,
      GeofenceSelected: null,
    },
  })
  const [theMap, setTheMap] = useState(null)
  const [theMapsReference, setTheMapsReference] = useState(null)
  const [zoom] = useState(19)
  const [theHeatMapOpts, setTheHeatMapOpts] = useState({
    positions: [],
    options: {
      radius: 30,
      opacity: 0.6,
    },
  })

  // Detect touch device and tablet optimization
  useEffect(() => {
    const checkDevice = () => {
      const isTouch = 'ontouchstart' in window || navigator.maxTouchPoints > 0
      const isTablet = window.innerWidth >= 768 && window.innerWidth <= 1024
      setIsMobile(isTouch && isTablet)
    }

    checkDevice()
    window.addEventListener('resize', checkDevice)
    return () => window.removeEventListener('resize', checkDevice)
  }, [])

  const handleApiLoaded = (map, mapsReference) => {
    setTheMap(map)
    setTheMapsReference(mapsReference)

    // Optimize for touch devices
    if (isMobile) {
      map.setOptions({
        gestureHandling: 'greedy',
        zoomControl: true,
        zoomControlOptions: {
          position: mapsReference.ControlPosition.RIGHT_BOTTOM
        },
        streetViewControl: false,
        fullscreenControl: false,
        mapTypeControl: false
      })
    }
  }

  const centerMap = () => {
    if (avoidAutoZoom === true) {
      return
    }
    if (theMapsReference) {
      const bounds = new theMapsReference.LatLngBounds()

      records.forEach(marker => {
        if (marker.latitude) {
          bounds.extend(
            new theMapsReference.LatLng(marker.latitude, marker.longitude)
          )
        }
      })

      theMap.fitBounds(bounds)
      //theMap.setZoom(zoom);
    }
  }
  if (state.center === undefined) {
  }

  const toggleDetails = obj => {

    if (obj.idCoche) {
      history.push(Routes.VehicleDetails.clean + obj.idCoche)
    } else {
      history.push(Routes.PlaceDetails.clean + obj.id)
    }
  }
  const [sectors, setSectors] = useState<Sector[]>([])
  const requestSectors = async () => {
    let Query = "OrganizationId=" + user.OrganizationId
    if (filter.from) {
      Query += `&from=${moment(filter.from).format(
        "YYYY-MM-DD"
      )}&until=${moment(filter.until).format("YYYY-MM-DD")}`
    }
    if (filter.sector) {
      Query += `&sector=${filter.sector}`
    }
    if (filter.name) {
      Query += `&name=${filter.name} `
    }

    //   var response = await Http.GetJsonAsync<pleelo.Helpers.APIModelRequestHelper>("/api/Expense/List?" + Query);
    let requestAPI = await API.getAction("place/sectorsWithCount", Query)

    if (requestAPI.data.status === "ok") {
      const result = requestAPI.data.response
      setSectors(result)
    }
  }

  // Main request with optimization
  const request = async (avoidZoom?: boolean, loadMore = false) => {
    if (avoidZoom) {
      setAvoidAutoZoom(true)
    }
    if (!user) {
      history.push(Routes.SignIn.path)
      return
    }

    setIsLoading(true)
    setLoadingProgress(0)

    try {
      let Query = "OrganizationId=" + user.OrganizationId
      if (filter.from) {
        Query += `&from=${moment(filter.from).format(
          "YYYY-MM-DD"
        )}&until=${moment(filter.until).format("YYYY-MM-DD")}`
      }
      if (filter.sector) {
        Query += `&sector=${filter.sector}`
      }
      if (filter.stageId) {
        Query += `&stageId=${filter.stageId}`
      }
      if (filter.categoryId) {
        Query += `&categoryId=${filter.categoryId} `
      }

      if (filter.placeStatusId) {
        Query += `&placeStatusId=${filter.placeStatusId} `
      }

      if (filter.assignedTo) {
        Query += `&assignedTo=${filter.assignedTo} `
      }
      if (filter.withVehicleVisits) {
        Query += `&withVehicleVisits=${filter.withVehicleVisits}`
      }

      Query += `&showFinished=${showFinished} `

      // Optimización inteligente según el modo de vista
      if (displayMode === "map") {
        // Para el MAPA: Cargar TODOS los registros pero con campos mínimos
        // Solo coordenadas, id y nombre básico para mostrar en el mapa
        Query += `&fields=id,name,latitude,longitude,latitudeStart,longitudeStart,placeStatusId,stageId,assignedTo`
      } else {
        // Para la LISTA: Usar paginación con más detalles
        const page = loadMore ? currentPage + 1 : 1
        Query += `&page=${page}&pageSize=${pageSize}`
        Query += `&fields=id,name,image,address,sector,city,region,country,assignedTo,assignedToObj,latitude,longitude,latitudeStart,longitudeStart,placeStatusId,stageId`
      }

      setLoadingProgress(30)

      let requestAPI = await API.getAction("place/list", Query)

      setLoadingProgress(70)

      if (requestAPI.data.status === "ok") {
        // Calcular tamaño aproximado del response para monitoreo
        const responseSize = new Blob([JSON.stringify(requestAPI.data)]).size
        const sizeInKB = (responseSize / 1024).toFixed(2)
        setRequestSize(`${sizeInKB} KB`)

        // Log en desarrollo para monitorear
        if (process.env.NODE_ENV === 'development') {
          console.log(`📦 Place list response size: ${sizeInKB} KB (${requestAPI.data.response.length} records)`)
        }

        const result = requestAPI.data.response
        const total = requestAPI.data.total || result.length

        setTotalRecords(total)

        if (displayMode === "map") {
          // En modo mapa, siempre reemplazar con todos los registros
          setRecords(result)
          setVisibleRecords(result)
          setCurrentPage(1)
        } else {
          // En modo lista, usar paginación
          if (loadMore) {
            // Agregar a los registros existentes
            setRecords(prev => [...prev, ...result])
            setCurrentPage(currentPage + 1)
            setVisibleRecords(prev => [...prev, ...result])
          } else {
            // Reemplazar registros
            setRecords(result)
            setCurrentPage(1)
            setVisibleRecords(result)
          }
        }
      }

      setLoadingProgress(100)
    } catch (error) {
      console.error("Error loading places:", error)
    } finally {
      setTimeout(() => {
        setIsLoading(false)
        setLoadingProgress(0)
      }, 300)
    }
  }
  const [placeStatus, setPlaceStatus] = useState<PlaceStatus[]>([])
  const requestStatus = async () => {
    let Query = "OrganizationId=" + user.OrganizationId

    //   var response = await Http.GetJsonAsync<pleelo.Helpers.APIModelRequestHelper>("/api/Expense/List?" + Query);
    let requestAPI = await API.getAction("placeStatus/list", Query)

    if (requestAPI.data.status === "ok") {
      const result = requestAPI.data.response
      setPlaceStatus(result)
    }
  }
  const [stages, setStages] = useState<Stage[]>([])
  const requestStages = async () => {
    let requestAPI = await API.getAction(
      "Stage/List?OrganizationId=" + user.OrganizationId
    )

    if (requestAPI.data.status === "ok") {
      setStages(requestAPI.data.response)
    }
  }

  const [categories, setCategories] = useState<Category[]>([])
  const requestCategories = async () => {
    let requestAPI = await API.getAction(
      "category/List?OrganizationId=" + user.OrganizationId
    )

    if (requestAPI.data.status === "ok") {
      setCategories(requestAPI.data.response)
    }
  }

  const [users, setUsers] = useState<User[]>([])
  const requestUsers = async () => {
    let requestAPI = await API.getAction(
      "users/List?OrganizationId=" + user.OrganizationId
    )

    if (requestAPI.data.status === "ok") {
      setUsers(requestAPI.data.response)
    }
  }
  const requestTrucks = async () => {
    let requestAPI = await API.getAction("agl/carLastPosition?OrganizationId=" + user.OrganizationId)

    if (requestAPI.data.status === "ok") {
      setRecordsVehicles(requestAPI.data.response)
    }
  }

  const vehicleInterval = useRef(null)

  const toggleVehicles = () => {
    console.log("toggle vehicles")
    setShowTrucks(!showTrucks)
  }

  useEffect(() => {
    if (showTrucks) {
      //means is goint to change to true
      requestTrucks()
      vehicleInterval.current = setInterval(() => {
        console.log("trigger vehicle interval", showTrucks)
        if (showTrucks) {
          requestTrucks()
        }
      }, 60000)
    } else {
      console.log("trigger vehicle interval to stop")
      setRecordsVehicles([])
      clearInterval(vehicleInterval.current)
    }
  }, [showTrucks])
  const [polygon, setPolygon] = useState([])
  const [avoidAutoZoom, setAvoidAutoZoom] = useState(false)
  const [selectedPlaces, setSelectedPlaces] = useState<PlaceRecord[]>([])

  //Read all the markers between the polygon definition
  const getPlacesByPolygon = () => {
    const places: PlaceRecord[] = []
    records.forEach(item => {
      let exist = theMapsReference.geometry.poly.containsLocation(
        { lat: item.latitude, lng: item.longitude },
        thePolygon
      )

      if (exist) {
        places.push(item)
      }
    })

    setSelectedPlaces(places)
  }
  const handleClickOnMap = (obj: { lat: number; lng: number }) => {
    if (mapMode === "drawPolygon") {
      setPolygon([
        ...polygon,
        {
          lat: obj.lat,
          lng: obj.lng,
        },
      ])
    }
  }

  useEffect(() => {
    if (records.length === 0) {
      return
    }
    const points: { lat: number; lng: number }[] = []
    const pins: Array<{ PositionType: string; latitude: number; longitude: number; item: PlaceRecord }> = []
    records.forEach(item => {
      points.push({
        lat: item.latitudeStart || item.latitude,
        lng: item.longitudeStart || item.longitude,
      })

      pins.push({
        PositionType: "Visita",
        latitude: item.latitudeStart || item.latitude,
        longitude: item.longitudeStart || item.longitude,
        item: item,
      })
    })
    setState({
      ...state,
      Pins: pins,
    })
    setTheHeatMapOpts({
      ...theHeatMapOpts,
      positions: points,
    })

    if (records && records.length > 0 && avoidAutoZoom === false) {
      centerMap()
    } else {
      setAvoidAutoZoom(false)
    }
  }, [records])

  useEffect(() => {
    if (mapMode === null) {
      setPolygon([])

      setSelectedPlaces([])
    } else if (mapMode === "drawPolygon") {
    }
  }, [mapMode])

  useEffect(() => {
    if (polygon.length > 0) {
      thePolygon?.setMap(null)
      if (theMapsReference) {
        setThePolygon(
          new theMapsReference.Polygon({
            paths: polygon,
            strokeColor: "#FF0000",
            strokeOpacity: 0.8,
            strokeWeight: 2,
            fillColor: "#FF0000",
            fillOpacity: 0.35,
          })
        )
      }
    } else {
      thePolygon?.setMap(null)
    }
  }, [polygon])

  useEffect(() => {
    thePolygon?.setMap(theMap)
  }, [thePolygon])

  // Initial data load - consolidated to avoid duplicate requests
  useEffect(() => {
    // Only load initial data if not in a detail view
    if (!chatId && !placeId) {
      request()
      requestSectors()
      requestStages()
      requestCategories()
      requestUsers()
      requestStatus()
    }
  }, [])

  // Reload when showFinished changes
  useEffect(() => {
    request()
  }, [showFinished])

  // Reload when switching between map and list to optimize fields
  useEffect(() => {
    if (records.length > 0) {
      request(true) // Reload with appropriate fields for the view mode
    }
  }, [displayMode])

  const [showAssignUsers, setShowAssignUsers] = useState(false)
  const [selectedPlace, setSelectedPlace] = useState<PlaceRecord | null>(null)
  const toggleAssignUsers = (obj?: PlaceRecord) => {
    setShowAssignUsers(!showAssignUsers)
    setSelectedPlace(obj || null)
    if (showAssignUsers) {
      request(true)
    }
  }
  const [showAddEditPlace, setShowAddEditPlace] = useState(false)
  const toggleAddEditPlace = () => {
    setShowAddEditPlace(!showAddEditPlace)
  }
  const { chatId, placeId } = useParams()
  const [showHeatMap, setShowHeatMap] = useState(false)
  const toggleHeatMap = async () => {
    setShowHeatMap(!showHeatMap)
    if (showHeatMap == false) {

      let dataRequest = await API.getAction("vehicleVisits/heatMap", "OrganizationId=" + user.OrganizationId);
      if (dataRequest.data.status === "ok") {
        let data = dataRequest.data.response;
        let heatmapData = data
          .filter(x => x.latitude > 0)
          .slice(0, isMobile ? 20 : data.length) // Limit vehicle markers on mobile
          .map((item) => {
            return ({
              lat: item.latitude,
              lng: item.longitude
            }

            )
          })
        // console.log(heatmapData)
        const heatmap = new theMapsReference.visualization.HeatmapLayer({
          data: heatmapData.map((point) => new theMapsReference.LatLng(point.lat, point.lng)),
          map: theMap,
          radius: 60,
          opacity: 0.7,
          maxIntensity: 20
        });
        heatmapRef.current = heatmap;
      }


    } else {
      if (heatmapRef.current) {
        heatmapRef.current.setMap(null);
        heatmapRef.current = null;
      }
    }
  }

  // Reload when navigating back from detail views
  useEffect(() => {
    // Skip on initial mount to avoid duplicate request
    if (isInitialMount.current) {
      isInitialMount.current = false;
      return;
    }

    // Only reload if we're coming back from a detail view (chatId or placeId was set, now it's cleared)
    if (!chatId && !placeId) {
      request(true)
    }
  }, [chatId, placeId])

  const ListOfPlacesUI = (records: PlaceRecord[]) => {
    if (!records || records.length === 0) {
      return (
        <div className="d-flex flex-column align-items-center justify-content-center" style={{ height: "60vh" }}>
          <i className="fa fa-map-marker-alt fa-3x text-muted mb-3"></i>
          <h5 className="text-muted">{t("No places found")}</h5>
          <p className="text-muted text-center">{t("Try adjusting your filters or add a new place")}</p>
          <button
            className="btn btn-primary"
            onClick={() => toggleAddEditPlace()}
          >
            <i className="fa fa-plus me-2"></i>
            {t("Add New Place")}
          </button>
        </div>
      )
    }

    return (
      <div style={{ overflow: "auto", height: "83vh", backgroundColor: "#f8f9fa" }} className="p-2">
        {/* Header with count and actions */}
        <div className="d-flex justify-content-between align-items-center mb-3 px-2">
          <div>
            <h6 className="mb-0 text-muted">
              <i className="fa fa-list me-2"></i>
              {records.length} {t("places found")}
              {totalRecords > records.length && (
                <small className="text-muted ms-2">
                  ({t("of")} {totalRecords})
                </small>
              )}
            </h6>
            {/* Indicador de tamaño en desarrollo */}
            {process.env.NODE_ENV === 'development' && requestSize && (
              <small className="text-info d-block mt-1">
                <i className="fa fa-database me-1"></i>
                {t("Response size")}: {requestSize}
              </small>
            )}
          </div>
          <div className="btn-group btn-group-sm">
            <button
              className="btn btn-outline-secondary"
              onClick={() => setDisplayMode("map")}
              title={t("Switch to map view")}
            >
              <i className="fa fa-map"></i>
            </button>
            <button
              className="btn btn-outline-primary"
              onClick={() => toggleAddEditPlace()}
              title={t("Add new place")}
            >
              <i className="fa fa-plus"></i>
            </button>
          </div>
        </div>

        {/* Places grid */}
        <div className="row g-3">
          {records.map((item, index) => {
            const hasImage = item.image && item.image.trim() !== ''
            const assignedUser = item.assignedToObj?.firstName || null

            return (
              <div className="col-12 col-md-6 col-lg-4" key={`place-${item.id || index}`}>
                <div className="card h-100 shadow-sm border-0 hover-shadow transition-all">
                  {/* Image section */}
                  <div
                    className="card-img-top position-relative overflow-hidden"
                    style={{ height: "200px", backgroundColor: "#e9ecef" }}
                  >
                    {hasImage ? (
                      <img
                        src={`${Settings.BasePathForAPI}file/getThumbnail?filename=${item.image}`}
                        loading="lazy"
                        alt={item.name}
                        className="w-100 h-100 object-fit-cover cursor-pointer"
                        onClick={() => toggleDetails(item)}
                        onError={(e) => {
                          const target = e.target as HTMLImageElement
                          target.style.display = 'none'
                          target.nextElementSibling?.classList.remove('d-none')
                        }}
                      />
                    ) : null}

                    {/* Fallback icon */}
                    <div className={`d-flex align-items-center justify-content-center h-100 ${hasImage ? 'd-none' : ''}`}>
                      <i className="fa fa-building fa-3x text-muted"></i>
                    </div>

                    {/* Status badges */}
                    <div className="position-absolute top-0 start-0 p-2">
                      {assignedUser && (
                        <span className="badge bg-success rounded-pill">
                          <i className="fa fa-user me-1"></i>
                          {t("Assigned")}
                        </span>
                      )}
                    </div>

                    {/* Action overlay */}
                    <div className="position-absolute top-0 end-0 p-2">
                      <div className="btn-group-vertical">
                        <button
                          className="btn btn-light btn-sm rounded-circle shadow-sm"
                          onClick={(e) => {
                            e.stopPropagation()
                            toggleDetails(item)
                          }}
                          title={t("View details")}
                        >
                          <i className="fa fa-eye"></i>
                        </button>
                      </div>
                    </div>
                  </div>

                  {/* Content section */}
                  <div className="card-body p-3">
                    {/* Title */}
                    <h6 className="card-title mb-2 fw-bold text-truncate" title={item.name}>
                      {item.name}
                    </h6>

                    {/* Address */}
                    <div className="text-muted small mb-2">
                      <i className="fa fa-map-marker-alt me-1 text-danger"></i>
                      <span className="text-truncate d-inline-block" style={{ maxWidth: "200px" }}>
                        {[item.address, item.sector, item.city, item.region, item.country]
                          .filter(Boolean)
                          .join(", ") || t("No address provided")}
                      </span>
                    </div>

                    {/* Additional info */}
                    <div className="row g-2 mb-3">
                      {item.sector && (
                        <div className="col-12">
                          <small className="text-muted">
                            <i className="fa fa-tag me-1"></i>
                            <strong>{t("Sector")}:</strong> {item.sector}
                          </small>
                        </div>
                      )}
                    </div>
                  </div>

                  {/* Footer actions */}
                  <div className="card-footer bg-white border-0 pt-0">
                    <div className="d-flex gap-2">
                      <button
                        className={`btn btn-sm flex-fill ${assignedUser ? 'btn-outline-primary' : 'btn-primary'}`}
                        onClick={(e) => {
                          e.stopPropagation()
                          toggleAssignUsers(item)
                        }}
                      >
                        <i className={`fa ${assignedUser ? 'fa-user-edit' : 'fa-user-plus'} me-1`}></i>
                        {assignedUser || t("Assign")}
                      </button>

                      <button
                        className="btn btn-sm btn-outline-secondary"
                        onClick={(e) => {
                          e.stopPropagation()
                          toggleDetails(item)
                        }}
                        title={t("View details")}
                      >
                        <i className="fa fa-arrow-right"></i>
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            )
          })}
        </div>

        {/* Load more button if there are more records (solo en modo lista) */}
        {displayMode === "list" && records.length < totalRecords && !isLoading && (
          <div className="text-center mt-4 mb-3">
            <div className="mb-2">
              <small className="text-muted">
                {t("Showing")} {records.length} {t("of")} {totalRecords} {t("places")}
              </small>
            </div>
            <button
              className="btn btn-primary"
              onClick={() => request(true, true)}
              disabled={isLoading}
            >
              {isLoading ? (
                <>
                  <span className="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true"></span>
                  {t("Loading...")}
                </>
              ) : (
                <>
                  <i className="fa fa-arrow-down me-2"></i>
                  {t("Load More")} ({Math.min(pageSize, totalRecords - records.length)} {t("more")})
                </>
              )}
            </button>
          </div>
        )}

        {/* Mostrar mensaje cuando se han cargado todos (solo en lista) */}
        {displayMode === "list" && records.length > 0 && records.length >= totalRecords && (
          <div className="text-center mt-4 mb-3">
            <small className="text-muted">
              <i className="fa fa-check-circle text-success me-1"></i>
              {t("All")} {totalRecords} {t("places loaded")}
            </small>
          </div>
        )}
      </div>
    )
  }
  const filterUI = () => {
    return (
      <div className="p-3">
        {/* Date Range Filter */}
        <div className="mb-4">
          <label className="form-label fw-bold text-white">
            <i className="fa fa-calendar me-2"></i>
            {t("Date Range")}
          </label>
          <div className="row g-2">
            <div className="col-6">
              <label className="form-label small text-light">{t("From")}</label>
              <input
                type="date"
                className="form-control form-control-sm"
                id="from"
                value={filter.from || ""}
                onChange={e => {
                  setFilter({
                    ...filter,
                    from: e.target.value,
                  })
                }}
              />
            </div>
            <div className="col-6">
              <label className="form-label small text-light">{t("To")}</label>
              <input
                type="date"
                className="form-control form-control-sm"
                id="until"
                value={filter.until || ""}
                onChange={e => {
                  setFilter({
                    ...filter,
                    until: e.target.value,
                  })
                }}
              />
            </div>
          </div>
        </div>

        {/* Sector Filter */}
        <div className="mb-4">
          <label className="form-label fw-bold text-white">
            <i className="fa fa-tag me-2"></i>
            {t("Sector")}
          </label>
          <select
            className="form-select form-select-sm"
            id="sector"
            value={filter.sector}
            onChange={e => {
              setFilter({
                ...filter,
                sector: e.target.value,
              })
            }}
          >
            <option value="">{t("All Sectors")}</option>
            {sectors &&
              sectors.map((item, index) => {
                return (
                  <option
                    key={index}
                    value={item.name}
                  >{`${item.name} (${item.count})`}</option>
                )
              })}
          </select>
        </div>

        {/* Name Filter */}
        <div className="mb-4">
          <label className="form-label fw-bold text-white">
            <i className="fa fa-search me-2"></i>
            {t("Search by Name")}
          </label>
          <input
            type="text"
            className="form-control form-control-sm"
            id="name"
            placeholder={t("Enter place name...")}
            value={filter.name}
            onChange={e => {
              const target = e.target as HTMLInputElement
              setFilter({
                ...filter,
                name: target.value,
              })
            }}
          />
        </div>

        {/* Assigned To Filter */}
        <div className="mb-4">
          <label className="form-label fw-bold text-white">
            <i className="fa fa-user me-2"></i>
            {t("Assigned To")}
          </label>
          <select
            className="form-select form-select-sm"
            id="assignedTo"
            value={filter.assignedTo || ""}
            onChange={e => {
              setFilter({
                ...filter,
                assignedTo: e.target.value,
              })
            }}
          >
            <option value="">{t("All Users")}</option>
            {users &&
              users.map((item, index) => {
                return (
                  <option
                    key={index}
                    value={item.id}
                  >{`${item.firstName} ${item.lastName}`}</option>
                )
              })}
          </select>
        </div>

        {/* Stage Filter */}
        <div className="mb-4">
          <label className="form-label fw-bold text-white">
            <i className="fa fa-flag me-2"></i>
            {t("Stage")}
          </label>
          <select
            className="form-select form-select-sm"
            id="stageId"
            value={filter.stageId || ""}
            onChange={e => {
              setFilter({
                ...filter,
                stageId: e.target.value,
              })
            }}
          >
            <option value="">{t("All Stages")}</option>
            {stages &&
              stages.map((item, index) => {
                return (
                  <option key={index} value={item.id}>{item.name}</option>
                )
              })}
          </select>
        </div>

        {/* Category Filter */}
        <div className="mb-4">
          <label className="form-label fw-bold text-white">
            <i className="fa fa-layer-group me-2"></i>
            {t("Category")}
          </label>
          <select
            className="form-select form-select-sm"
            id="categoryId"
            value={filter.categoryId || ""}
            onChange={e => {
              setFilter({
                ...filter,
                categoryId: e.target.value,
              })
            }}
          >
            <option value="">{t("All Categories")}</option>
            {categories &&
              categories.map((item, index) => {
                return (
                  <option key={index} value={item.id}>{item.name}</option>
                )
              })}
          </select>
        </div>

        {/* Status Filter */}
        <div className="mb-4">
          <label className="form-label fw-bold text-white">
            <i className="fa fa-info-circle me-2"></i>
            {t("Status")}
          </label>
          <select
            className="form-select form-select-sm"
            id="placeStatusId"
            value={filter.placeStatusId || ""}
            onChange={e => {
              setFilter({
                ...filter,
                placeStatusId: e.target.value,
              })
            }}
          >
            <option value="">{t("All Statuses")}</option>
            {placeStatus &&
              placeStatus.map((item, index) => {
                return (
                  <option key={index} value={item.id}>{item.name}</option>
                )
              })}
          </select>
        </div>

        {/* Sitios con visita de despacho */}
        <div className="mb-4">
          <label className="form-label fw-bold text-white">
            <i className="fa fa-truck me-2"></i>
            {t("Con visita de despacho")}
          </label>
          <select
            className="form-select form-select-sm"
            id="withVehicleVisits"
            value={filter.withVehicleVisits || ""}
            onChange={e => {
              setFilter({
                ...filter,
                withVehicleVisits: e.target.value,
              })
            }}
          >
            <option value="">{t("Todos")}</option>
            <option value={"true"}>{t('Si')}</option>
            <option value={"false"}>{t('No')}</option>
          </select>
        </div>

        {/* Clear Filters Button */}
        <div className="mb-3">
          <div className="row g-2">
            <div className="col-12">
              <button
                className={`btn btn-outline-light btn-sm w-100 ${isMobile ? 'btn-lg' : ''}`}
                onClick={() => {
                  setFilter({
                    from: null,
                    until: null,
                    sector: "",
                    name: "",
                    stageId: null,
                    categoryId: null,
                    assignedTo: null,
                    placeStatusId: null,
                    withVehicleVisits: null,
                  })
                }}
                style={{ minHeight: isMobile ? '48px' : 'auto' }}
              >
                <i className="fa fa-eraser me-2"></i>
                {t("Clear Filters")}
              </button>
            </div>

          </div>
        </div>
      </div>
    )
  }
  if (!user) {
    window.location.href = Routes.SignIn.path
    return null
  }
  return (
    <>
      {showAddEditPlace ? (
        <AddEditPlace show={true} toggle={toggleAddEditPlace} />
      ) : null}
      {showAssignUsers ? (
        <AssignUser
          show={showAssignUsers}
          toggle={toggleAssignUsers}
          place={selectedPlace}
        />
      ) : null}
      {showPriority && (
        <PlacePriority show={showPriority} toggle={togglePriorityModal} />
      )}
      {/* HEADER */}
      <Card className="shadow-sm my-4">
        <Card.Body className="px-0 py-2">
          <Row className="mx-0">
            <Col className="text-start col-auto">
              <button
                className="btn btn-primary btn-sm me-2"
                onClick={() => {
                  toggleAddEditPlace()
                }}
              >
                <i className="fa fa-plus"></i>
              </button>
              <button
                className={`btn btn-warning ${isMobile ? 'btn-lg' : 'btn-sm'} `}
                onClick={() => togglePriorityModal()}
                style={{ minHeight: isMobile ? '48px' : 'auto', minWidth: isMobile ? '48px' : 'auto' }}
              >
                <i className="fa fa-star"></i>
                {isMobile && <span className="ms-2">{t("Priority")}</span>}
              </button>
            </Col>
            <Col className="text-end col-auto ml-auto">
              <button className={"btn btn-sm me-2 " + (showHeatMap ? " btn-danger" : " btn-outline-danger")} onClick={() => toggleHeatMap()} title={t("Toggle Heatmap")}>
                <i className="fa fa-thermometer-half"></i>
                {isMobile && <span className="ms-2">{t("Heatmap")}</span>}
              </button>
              <div className="btn-group float-end">
                <button
                  className={
                    `btn ${isMobile ? 'btn-lg' : 'btn-sm'} position-relative ` +
                    (showFilter ? "btn-primary" : "btn-secondary")
                  }
                  onClick={() => {
                    setShowFilter(!showFilter)
                  }}
                  style={{ minHeight: isMobile ? '48px' : 'auto', minWidth: isMobile ? '48px' : 'auto' }}
                >
                  <i className="fa fa-filter"></i>
                  {isMobile && <span className="ms-2">{t("Filter")}</span>}
                  {(() => {
                    const activeFilters = Object.values(filter).filter(val =>
                      val !== null && val !== ""
                    ).length;
                    return activeFilters > 0 ? (
                      <span className="position-absolute top-0 start-100 translate-middle badge rounded-pill bg-warning text-dark">
                        {activeFilters}
                        <span className="visually-hidden">{t("active filters")}</span>
                      </span>
                    ) : null;
                  })()}
                </button>
                <button
                  className={
                    `btn ${isMobile ? 'btn-lg' : 'btn-sm'} ` +
                    (showHistory ? "btn-primary" : "btn-secondary")
                  }
                  onClick={() => {
                    toggleHistoryModal()
                  }}
                  style={{ minHeight: isMobile ? '48px' : 'auto', minWidth: isMobile ? '48px' : 'auto' }}
                >
                  <i className="fa fa-history"></i>
                  {isMobile && <span className="ms-2">{t("History")}</span>}
                </button>
                <button
                  className={`btn btn-primary ${isMobile ? 'btn-lg' : 'btn-sm'}`}
                  onClick={() => {
                    if (displayMode !== "list") {
                      setShowFilter(true)
                    }
                    setDisplayMode("list" === displayMode ? "map" : "list")
                  }}
                  style={{ minHeight: isMobile ? '48px' : 'auto', minWidth: isMobile ? '48px' : 'auto' }}
                >
                  <i
                    className={
                      "fa fa-" + (displayMode === "list" ? "map" : "list")
                    }
                  ></i>
                  {isMobile && (
                    <span className="ms-2">
                      {displayMode === "list" ? t("Map") : t("List")}
                    </span>
                  )}
                </button>
              </div>

              <button
                className={
                  `btn ${isMobile ? 'btn-lg' : 'btn-sm'} mx-2 ` +
                  (showTrucks ? "btn-primary" : "btn-secondary")
                }
                onClick={() => {
                  toggleVehicles()
                }}
                style={{ minHeight: isMobile ? '48px' : 'auto', minWidth: isMobile ? '48px' : 'auto' }}
              >
                <i className="fa fa-truck"></i>
                {isMobile && <span className="ms-2">{t("Vehicles")}</span>}
              </button>
              <button
                className={
                  `btn ${isMobile ? 'btn-lg' : 'btn-sm'} mx-2 ` +
                  (showFinished ? "btn-primary" : "btn-secondary")
                }
                onClick={() => {
                  setShowFinished(!showFinished)
                }}
                style={{ minHeight: isMobile ? '48px' : 'auto', minWidth: isMobile ? '48px' : 'auto' }}
              >
                {showFinished ? t("Hide") : t("Show")} {t("Finished")}
              </button>

            </Col>
          </Row>
        </Card.Body>
      </Card>
      {/* BODY */}
      <Card className="my-4 shadow-sm">
        <Card.Body className=" p-0">
          <Row className="mx-0 p-0">
            {/* FILTER */}
            {showFilter && (
              <Col
                xs={12}
                md={isMobile ? 12 : 3}
                lg={isMobile ? 12 : 2}
                className={`bg-dark text-light ${isMobile ? 'position-absolute' : ''}`}
                style={isMobile ? {
                  zIndex: 1000,
                  height: '100vh',
                  overflowY: 'auto',
                  top: 0,
                  left: 0,
                  right: 0
                } : {}}
              >
                {isMobile && (
                  <div className="d-flex justify-content-between align-items-center p-3 border-bottom">
                    <h5 className="mb-0 text-white">{t("Filters")}</h5>
                    <button
                      className="btn btn-outline-light btn-sm"
                      onClick={() => setShowFilter(false)}
                      style={{ minHeight: '40px', minWidth: '40px' }}
                    >
                      <i className="fa fa-times"></i>
                    </button>
                  </div>
                )}
                <button
                  className={`btn btn-secondary ${isMobile ? 'btn-lg' : 'btn-sm'} mb-2 mt-4`}
                  onClick={() => {
                    switch (mapMode) {
                      case null:
                        setMapMode("drawPolygon")
                        return
                      case "drawPolygon":
                        setMapMode(null)
                        return
                      default:
                        setMapMode(null)
                    }
                  }}
                  style={{ minHeight: isMobile ? '48px' : 'auto' }}
                >
                  {mapMode === null
                    ? t("Select by Polygon")
                    : mapMode === "drawPolygon"
                      ? t("Clear")
                      : ""}
                </button>
                <Row>
                  <Col style={{
                    overflowY: "auto",
                    height: isMobile ? "65vh" : "70vh",
                    padding: isMobile ? '1rem' : undefined
                  }}>
                    {mapMode === null && filterUI()}

                    {mapMode === "drawPolygon" &&
                      ListOfPlacesUI(selectedPlaces)}
                  </Col>
                </Row>
                {mapMode === "drawPolygon" ? (
                  <button
                    className={`btn btn-secondary ${isMobile ? 'btn-lg' : 'btn-sm'} btn-block my-2`}
                    onClick={getPlacesByPolygon}
                    style={{ minHeight: isMobile ? '48px' : 'auto' }}
                  >
                    {t("Get Places")}
                  </button>
                ) : (
                  <button
                    className={`btn btn-secondary ${isMobile ? 'btn-lg' : 'btn-sm'} btn-block my-2`}
                    onClick={async () => request(true)}
                    style={{ minHeight: isMobile ? '48px' : 'auto' }}
                  >
                    {t("Filter")}
                  </button>
                )}
              </Col>
            )}
            <Col
              className="p-0"
              xs={12}
              md={showFilter ? 9 : 12}
              lg={showFilter ? 10 : 12}
            >

              {displayMode === "list" ? (
                <>
                  {isLoading && records.length === 0 ? (
                    <div className="d-flex flex-column align-items-center justify-content-center" style={{ height: "60vh" }}>
                      <div className="spinner-border text-primary mb-3" role="status" style={{ width: "3rem", height: "3rem" }}>
                        <span className="visually-hidden">{t("Loading...")}</span>
                      </div>
                      <h5 className="text-muted">{t("Loading places...")}</h5>

                      {/* Barra de progreso */}
                      {loadingProgress > 0 && (
                        <div className="w-50 mt-3">
                          <div className="progress" style={{ height: "8px" }}>
                            <div
                              className="progress-bar progress-bar-striped progress-bar-animated"
                              role="progressbar"
                              style={{ width: `${loadingProgress}%` }}
                              aria-valuenow={loadingProgress}
                              aria-valuemin={0}
                              aria-valuemax={100}
                            ></div>
                          </div>
                          <small className="text-muted mt-2 d-block text-center">{loadingProgress}%</small>
                        </div>
                      )}

                      <p className="text-muted mt-2">{t("Please wait while we fetch your data")}</p>

                      {/* Información de optimización */}
                      <small className="text-muted mt-3">
                        <i className="fa fa-info-circle me-1"></i>
                        {t("Loading")} {pageSize} {t("places per page")}
                      </small>
                      <small className="text-muted d-block mt-1">
                        💡 {t("Map view loads all locations with minimal data")}
                      </small>
                    </div>
                  ) : (
                    <>
                      {isLoading && records.length > 0 && (
                        <div className="alert alert-info d-flex align-items-center" role="alert">
                          <div className="spinner-border spinner-border-sm me-2" role="status">
                            <span className="visually-hidden">{t("Loading...")}</span>
                          </div>
                          <div>{t("Loading more places...")}</div>
                        </div>
                      )}
                      {ListOfPlacesUI(records)}
                    </>
                  )}
                </>
              ) : (
                <>
                  {/* Loading indicator for map view */}
                  {isLoading && (
                    <div
                      className="position-absolute top-0 start-50 translate-middle-x mt-3"
                      style={{ zIndex: 1000 }}
                    >
                      <div className="alert alert-info d-flex align-items-center shadow" role="alert">
                        <div className="spinner-border spinner-border-sm me-2" role="status">
                          <span className="visually-hidden">{t("Loading...")}</span>
                        </div>
                        <div>
                          <strong>{t("Loading places...")}</strong>
                          {totalRecords > 0 && (
                            <small className="d-block">
                              {records.length} / {totalRecords} {t("loaded")}
                            </small>
                          )}
                        </div>
                      </div>
                    </div>
                  )}

                  <GoogleMapReact
                    ref={GoogleMapRef}
                    onClick={handleClickOnMap}
                    yesIWantToUseGoogleMapApiInternals={true}
                    onGoogleApiLoaded={({ map, maps }) =>
                      handleApiLoaded(map, maps)
                    }
                    bootstrapURLKeys={{
                      key: Settings.GoogleMapsKey,
                      libraries: ['visualization']
                    }}
                    style={{
                      width: "100%",
                      minHeight: isMobile ? "400px" : "300px",
                      height: isMobile ? "75vh" : "75vh",
                      position: "relative",
                    }}
                    center={{ lat: state.center.lat, lng: state.center.lng }}
                    defaultZoom={zoom}
                    options={{
                      gestureHandling: isMobile ? 'cooperative' : 'greedy',
                      zoomControl: true,
                      zoomControlOptions: {
                        position: 9, // TOP_RIGHT
                        style: isMobile ? 1 : 0 // LARGE : DEFAULT
                      },
                      mapTypeControl: false,
                      streetViewControl: false,
                      fullscreenControl: !isMobile,
                      restriction: {
                        latLngBounds: {
                          north: 85,
                          south: -85,
                          west: -180,
                          east: 180
                        },
                        strictBounds: true
                      },
                      minZoom: 2,
                      maxZoom: isMobile ? 18 : 21
                    }}
                  >
                    {/* Render limited records for performance on mobile */}
                    {!showHeatMap && visibleRecords
                      .filter(x => x.latitude > 0)
                      .slice(0, isMobile ? 50 : visibleRecords.length) // Limit markers on mobile
                      .map((item, index) => {
                        return (
                          <PinComponent
                            Type={"Visit"}
                            lat={item.latitude}
                            key={`visit-${item.id || index}`}
                            item={item}
                            toggle={toggleDetails}
                            lng={item.longitude}
                            text={item.name}
                          />
                        )
                      })}
                    {recordsVehicles
                      .filter(x => x.latitud > 0)
                      .slice(0, isMobile ? 20 : recordsVehicles.length) // Limit vehicle markers on mobile
                      .map((item, index) => {
                        return (
                          <PinComponent
                            Type={"vehicle"}
                            lat={item.latitud}
                            key={`vehicle-${item.id || index}`}
                            item={item}
                            toggle={toggleDetails}
                            lng={item.longitud}
                            text={
                              item.coche.marca +
                              " " +
                              item.coche.modelo +
                              " " +
                              item.coche.ficha
                            }
                          />
                        )
                      })}

                    {/* Indicador de lugares cargados en el mapa */}
                    {!isLoading && records.length > 0 && (
                      <div
                        style={{
                          position: 'absolute',
                          top: '10px',
                          left: '10px',
                          background: 'rgba(255, 255, 255, 0.95)',
                          color: '#333',
                          padding: '10px 15px',
                          borderRadius: '8px',
                          fontSize: '13px',
                          boxShadow: '0 2px 8px rgba(0,0,0,0.2)',
                          border: '1px solid rgba(0,0,0,0.1)',
                          zIndex: 10
                        }}
                      >
                        <div className="d-flex align-items-center">
                          <i className="fa fa-map-marker-alt text-primary me-2"></i>
                          <div>
                            <strong>{records.filter(x => x.latitude > 0).length}</strong> {t("locations")}
                            {process.env.NODE_ENV === 'development' && requestSize && (
                              <small className="text-muted d-block" style={{ fontSize: '11px' }}>
                                {requestSize}
                              </small>
                            )}
                          </div>
                        </div>
                      </div>
                    )}

                    {isMobile && visibleRecords.length > 50 && (
                      <div
                        style={{
                          position: 'absolute',
                          top: '10px',
                          left: '10px',
                          background: 'rgba(0,0,0,0.7)',
                          color: 'white',
                          padding: '8px 12px',
                          borderRadius: '4px',
                          fontSize: '12px'
                        }}
                      >
                        {t("Showing")} 50 {t("of")} {visibleRecords.length} {t("locations")}
                      </div>
                    )}
                  </GoogleMapReact>
                </>
              )}
              <Row className="mx-0">
                <Col xs={12} >
                  <SummaryByStage filter={filter} />

                  <SummaryByStatus filter={filter} />

                  <SummaryVehicleVisits />
                </Col>

              </Row>
            </Col>
          </Row>
        </Card.Body>
      </Card >

      {/* VisitHistory Sidebar - Optimized lateral view */}
      < VisitHistorySidebar
        show={showHistory}
        toggle={toggleHistoryModal}
        placement="end"
        allowMapInteraction={true}
      />
    </>
  )
}

export default Visits
